<template>
  <div class="news-content-container">
    <back-open-chenter />
    <div class="news-content-panel">
      <div class="news-title">重磅报告 | 智创互联·2023金融科技十大趋势（附下载）</div>
      <div class="news-date">2023年5月23日</div>
      <div class="news-content">
        <div>
          <div class="image-panel">
            <img class="news-image" src="../img/detail/Information/news17/news17_17.gif"/>
          </div>
        </div>
        <div>
          <div class="image-panel">
            <img class="news-image" src="../img/newscenter/news65.png"/>
          </div>
        </div>
        <div class="news-content-mark">
          <div>腾讯研究院&腾讯云&腾讯安全&微信支付&腾讯广告&腾讯优图&招商银行&中信建投证券</div>
          <div>联合课题研究项目组</div>
        </div>
        <p>
          近期，国家印发《数字中国建设整体布局规划》，提出建设数字中国是推进中国式现代化的重要引擎，要求强化数字中国的关键能力。党的二十大报告提出，“加快发展数字经济，促进数字经济和实体经济深度融合”，标志着未来金融科技将迈入高质量发展的新阶段。
        </p>
        <p>
          在数字中国的建设中，金融科技起到了非常重要的推动作用。今年的《智创互联·2023金融科技十大趋势报告》，主题词是智创互联：智能创新与全真互联。涵盖自主创新、生物识别技术、生成式AI、数字原生、全域营销、可持续金融、隐私计算、动态风险治理、全真互联和Web3共计十大趋势。《报告》全景呈现了在数实融合的趋势下，金融业在打破线上线下的边界，推进数字化、全真化和智能化过程中的探索路径和前沿洞察。因此，实现智创互联，赋能金融数字化升级，支持实体经济提质增效，金融科技大有可为。
        </p>
        <p>
          我国金融科技正在从“立柱架梁”向“积厚成势”的新阶段迈进。目前金融机构数字化转型的深入，以及数据要素潜能的逐步释放，金融科技在提升金融体系运行效率、服务实体经济高质量发展方面的价值将进一步凸显。为了探讨金融科技在新阶段的发展方向，<strong>腾讯研究院、腾讯云、腾讯安全、微信支付、腾讯广告、腾讯优图实验室、招商银行、中信建投证券联手启动金融科技趋势研究项目</strong>，经过5个月的调研，汇集了金融科技领域30余位行业专家的实践思考，<strong>形成近五万字报告成果《智创互联·2023金融科技十大趋势报告》</strong>。
        </p>
        <p>
          《报告》从<strong>创新篇、智能篇、普惠篇、安全篇、融合篇</strong>五个方面总结了十大金融科技前沿趋势，为金融科技产业的智能创新，以及科技与金融的深度融合发展提供实践参考，获得北京大学国家发展研究院副院长、北京大学数字金融研究中心主任黄益平等多位著名专家的指导和推荐。
        </p>
        <div>
          <div class="image-panel">
            <img class="news-image" src="../img/detail/Information/news65/news65_1.png"/>
          </div>
        </div>
        <div class="news-content-mark">
          <h2>1. 专家点评</h2>
        </div>
        <div>
          <p>
            数字经济时代，金融机构正全面拥抱智能科技，积极借助金融科技赋能实体经济，在激发数字活力的同时释放数字红利。本报告结合目前政策及行业发展，通过分析十个趋势方向及案例，给出有价值的研究成果，对于更好理解金融与科技的融合发展及新的增长点具有启示意义。
          </p>
          <div class="right-text strong">——黄益平</div>
          <div class="right-text">北京大学国家发展研究院副院长、教授</div>
          <div class="right-text">北京大学数字金融研究中心主任</div>
        </div>
        <div>
          <p>
            在万物智慧互联的时代，数字经济的发展离不开创新科技的支持。为加快数字中国建设，金融业持续提升智能化、数字化能力。报告以智创互联为主题，详实介绍了前沿科技未来的发展趋势并辅以案例分析，对金融科技发展提出前瞻性展望。
          </p>
          <div class="right-text strong">——高峰</div>
          <div class="right-text">中国银行业协会首席信息官</div>
        </div>
        <div>
          <p>
            国家“十四五”规划中对于金融科技创新和金融机构数字化转型提出明确要求，要求金融机构稳妥发展金融科技，加快数字化转型。本报告对金融科技的发展趋势做出了展望，对金融机构如何规划发展金融科技具有深刻启示。
          </p>
          <div class="right-text strong">——王辉</div>
          <div class="right-text">中央财经大学金融学院党委书记、教授</div>
        </div>
        <div>
          <p>
            报告展现了十大金融科技的趋势应用，趋势案例和趋势展望。深入研究金融科技的应用情况，辅以分析金融科技应用的案例，推理出金融科技的发展趋势，其对金融科技的未来发展规划有重要的参考价值。
          </p>
          <div class="right-text strong">——徐翊鸣</div>
          <div class="right-text">腾讯云副总裁</div>
        </div>
        <div class="news-content-mark">
          <h2>2. 2023金融科技十大趋势</h2>
          <div>
            趋势一：自主创新成为金融数字化转型关键任务
          </div>
        </div>
        <p>
          金融信息系统作为国家关键的信息基础设施，直接关系到国家经济、社会的正常运行。在数字化转型过程中，构建自主创新、稳定运行的金融系统，成为金融机构数字化的关键任务。金融信息系统的自主创新包含了底层基础硬件、中间层基础软件、上层核心应用软件等方面的变革，以及在建设过程中发挥重要作用的网络安全、云平台、终端外设等环节。
        </p>
        <p>
          腾讯云在国产化操作系统、金融级分布式数据库、中间件、金融云、国密改造等领域均有成熟的解决方案布局，助力中信建投证券、招商银行等金融机构完成了自主创新改造。未来，金融自主创新将带动金融机构数字化转型更加深入，金融信创也将从办公 OA 等一般系统的替换，逐渐向核心系统替换扩展的应用深化期转变。此外，覆盖的金融机构范围将向数量占比更为庞大的中小银行、券商和保险机构扩展，这类机构相对更依赖于产品经验丰富的外部解决方案厂商和服务提供商。金融云、国产数据库等解决方案市场规模有望进一步提升。
        </p>
        <div>
          <div class="image-panel">
            <img class="news-image" src="../img/detail/Information/news65/news65_2.png"/>
          </div>
        </div>
        <div class="news-content-mark">
          <div>
            趋势二：生物识别技术在支付领域的创新应用
          </div>
        </div>
        <p>
          当前生物识别的发展以多模态识别为主流，掌纹、掌静脉识别是其中最为先进的识别技术。刷掌支付是对多元生物识别技术的更深层次应用，通过持续创新攻克了“掌纹+掌静脉”融合识别等多项技术难题，在场景应用创新上不断取得突破，成为了现行支付方式的有益补充，提升了支付的准确度、安全性和隐私性。
        </p>
        <p>
          微信刷掌服务在意愿、隐私、便捷等方面均有独特的优势，是隐私监管趋严大背景下的创新产物，可以与刷脸支付形成良好互补，共同丰富微信支付生态体系，为用户带来更好的使用体验。2022 年，微信刷掌服务已通过“微信刷掌服务”小程序在部分场景下开始了小范围试点。在落地更多线下消费场景的同时，微信刷掌也打通融入进了门禁、打卡等多元的生活化场景，目前在商超、餐厅、游乐场等具体场景进行了测试，带来了“玩水不用带手机”、“刷掌就能就餐”等等更便捷的体验。未来，微信支付将与商家一起联合打造更多刷掌创新科技应用场景。
        </p>
        <div>
          <div class="image-panel">
            <img class="news-image" src="../img/detail/Information/news65/news65_3.png"/>
          </div>
        </div>
        <div class="news-content-mark">
          <div>
            趋势三：生成式AI为金融科技注入新生产力
          </div>
        </div>
        <p>
          生成式AI是一种机器学习算法，能够从训练数据中生成新的数据，包括表格/结构化数据，图像、视频、语音等媒体数据，以及文本数据。生成式AI 与金融行业的结合可能会沿着两种形式发展：第一种是GaaS（Generative AI as a Service），以“开箱即用”的服务形式提供生成式AI 技术；第二种是GaaC（Generative AI as a Component），以组件形式提供生成式AI 技术，并将其嵌入到已有的金融服务工作流程。
        </p>
        <div>
          <div class="image-panel">
            <img class="news-image" src="../img/detail/Information/news65/news65_4.png"/>
          </div>
        </div>
        <p>
          摩根士丹利财富管理公司用GPT-4 来构建公司内部的聊天机器人，帮助财富管理顾问来检索涵盖投资策略、市场研究和评论以及分析师洞察的信息库。彭博社于近期发布了为金融界打造的大语言模型（LLM）——BloombergGPT，已经在其内部使用，帮助金融分析师和投资经理更好地分析和预测市场趋势、评估投资风险和机会。长远来看，生成式AI 有效地拓展了金融科技创新的疆界，并且提供了一种前所未有的新生产力，其影响甚至可能演变成对现有金融业务流程的革新和重组，值得所有的金融机构关注、跟进以及应用。
        </p>
        <div class="news-content-mark">
          <div>
            趋势四：数字原生打造金融数字化新底座
          </div>
        </div>
        <p>
          从数字化到云化，从云化再向数字原生进化，数字原生是金融机构IT架构全面进阶的新机遇。目前大部分银行、金融机构的云原生布局已经从最初的容器、微服务等技术再到云原生技术扩容，再到现在数字原生布局成型。在金融场景下，云原生技术可以提高金融行业的数字化和智能化水平，从而实现更加高效、灵活和安全的金融服务。
        </p>
        <div>
          <div class="image-panel">
            <img class="news-image" src="../img/detail/Information/news65/news65_5.png"/>
          </div>
        </div>
        <p>
          腾讯云信创专有云TCS平台是腾讯云与保险公司等金融机构共同打造的云原生体系，全面支撑国内保险机构的数字化转型和国产化改造。截止到目前，腾讯云TCS平台已协助保险机构完成40 余个系统、200 多个应用的云原生改造，包括自然人、移动保全、科技个险等多个核心业务系统，日均服务调用量突破千万次。在数字原生时代，云原生技术与金融行业的应用将持续增长并不断发展，以满足金融机构不断变化的业务需求和客户期望，科技厂商也将与金融机构共同推动技术的不断发展。
        </p>
        <div class="news-content-mark">
          <div>
            趋势五：金融营销全域化破局获客活客难题
          </div>
        </div>
        <p>
          全域经营，是当下数字化经营的主流模式，由腾讯在2022年给出了明确定义。全域营销则是企业以数字化手段建立的，以消费者为中心，整合线上线下场景，整合公域私域触点的一体化营销模式。在金融机构面临用户增长瓶颈的背景下，全域营销在银行、证券、保险等子行业均有较多应用场景，包括新用户触达、新产品推介、用户对持续运营和转化、品牌形象建设等。
        </p>
        <div>
          <div class="image-panel">
            <img class="news-image" src="../img/detail/Information/news65/news65_6.png"/>
          </div>
        </div>
        <p>
          在产品获客、活客方面，微众银行围绕腾讯广告生态，深度开展小微企业金融的全域经营探索。经过四年的合作，微众银行企业金融的公众号粉丝增粉超过千万，拉新获客取得显著成效。在私域运营方面，企业微信已在多家券商得到深度应用，助力券商打造私域经营体系，同时有效解决微信的信息过载。未来，AIGC、数字人等数字技术及应用，将为私域运营的智能化升级提供可能。基于智能化的数字工具组件，金融机构将进一步提升私域运营能力，从而解决私域运营培训成本高、人才缺失的问题。 
        </p>
        <div class="news-content-mark">
          <div>
            趋势六：金融科技催化可持续金融创新发展
          </div>
        </div>
        <p>
          可持续金融泛指一切为实现可持续发展而实施的金融活动，将可持续发展融入到金融政策、金融产品和金融行为之中，以金融资源的配置、调整和优化实现既定目标。本质上看，可持续金融是通过金融的方法将经济利益、社会发展和环境效益的融合与可持续发展相连，围绕可持续发展诸多议题，衍生出绿色金融、普惠金融、转型金融、ESG 等概念。金融科技在可持续金融中的运用前景巨大，已经覆盖到绿色金融、普惠金融、ESG 投融资、转型金融等重点领域。
        </p>
        <p>
          腾讯云霖中小企业金融服务平台，是腾讯云联合多家银行推出的以金融科技助力中小企业普惠融资服务的创新产品。引入了腾讯亿级企业大数据能力，基于联邦学习框架建立合规、安全的风控运营体系，通过腾讯+本地运营合作模式，构建了涵盖政府部门、金融机构、产业机构和数字科技企业的“政-金-产-数”普惠金融新生态，并连接政府、金融机构、产业场景，形成了可复制的普惠金融落地模式。未来，可持续金融在未来全球可持续发展中将扮演愈发重要的角色，要重视金融科技支持可持续金融发展，持续推动金融科技在多个维度发挥更重要的作用。
        </p>
        <div>
          <div class="image-panel">
            <img class="news-image" src="../img/detail/Information/news65/news65_7.png"/>
          </div>
        </div>
        <div class="news-content-mark">
          <div>
            趋势七：隐私计算助力金融数据可信流通
          </div>
        </div>
        <p>
          隐私计算（Privacy Computing）是一种由两个或多个参与方联合计算的技术和系统，参与方在不泄露各自数据的前提下通过协作对数据进行联合机器学习和联合分析的技术，核心是能够保障数据在流通与融合过程中的“可用不可见”。 隐私计算常见的流派包括可信计算、联邦学习、多方安全计算。
        </p>
        <p>
          腾讯安全隐私计算平台基于联邦学习、多方安全计算、可信执行环境等隐私数据保护技术，在保证原始数据不出本地的情况下可以支持联合统计、联合计算和联合建模、安全求交、隐匿查询等功能，使得各合作机构既能保障数据安全，又能发挥数据最大价值，实现数据可用不可见，为数据可信流通提供安全底座。目前，腾讯的隐私计算解决方案已经在银行、新金融机构、信贷机构、保险、证券等落地，具体的场景包括信贷风控建模、精准营销、多方联合统计等。
        </p>
        <div>
          <div class="image-panel">
            <img class="news-image" src="../img/detail/Information/news65/news65_8.png"/>
          </div>
        </div>
        <div class="news-content-mark">
          <div>
            趋势八：动态风险治理打造数字风控新模式
          </div>
        </div>
        <p>
          动态风险治理（dynamic risk governance，DRG）是基于组织层面的动态风险治理体系。组织通过实施动态风险治理，针对每种风险适当地定制化风险治理，使组织能够更好地管理风险并降低保障成本。DRG 的实施需要考虑风险管理数字化，组织将数据集中化管理，持续进行风险分析，并建立组织风险视图，自动化持续跟踪业务风险、组织风险和数据风险，实现对风险分析过程的全面治理。
        </p>
        <p>
          腾讯安全天御决策操作系统，聚焦数据分析、风险感知、AI 决策，金融机构可基于该操作系统与现有系统兼容互通，补齐数智化业务和人才短板，打造统一的风控中台。光大银行是最早实践风控中台的头部银行之一。在银行科技金融转型战略牵引下，光大银行联合腾讯云搭建了一套基于大数据和人工智能以及专家经验策略集合的智能风控决策体系，实现电商、社交、出行、教育、医疗等多类消费场景的金融化和互联网化，先后在欺诈检测、风险评估、预警催收等多个风控环节进行智能风控产品创新，并实现成果转化。
        </p>
        <div>
          <div class="image-panel">
            <img class="news-image" src="../img/detail/Information/news65/news65_9.png"/>
          </div>
        </div>
        <div class="news-content-mark">
          <div>
            趋势九：全真互联加速金融数字化转型
          </div>
        </div>
        <p>
          全真互联是通过多种终端和形式，实现对真实世界全面感知、连接和交互的系列技术集合和数实融合创新模式。全真互联时代下的金融科技服务，旨在创建一种以用户为中心、以数据为驱动、以全真为特色的新型普惠金融服务，以支持线上服务智能化、沉浸式的金融服务模式。全真互联可应用于金融科技全链条场景，包括组织管理与机构治理、客户服务与业务运营、经营决策与产品创新和研发实现与科技治理四个环节。
        </p>
        <p>
          某国有大型银行已借助科技，赋能场景、渠道、业务等传统模式创新，开展建设全行音视频能力平台的全真互联转型实践。从具体的实施方案来看，银行利用本地支行网点和异地分支机构的数据中心为基础设施，通过AI系统、在线音视频能力平台及数据中台、新客服平台等相关系统，构建高效协同的技术应用整体框架，对内加速数据与资源的流动，对外以全真互联形态对接企业、客户、市场等。在业务场景开展层面，银行主要以远程视频服务、在线业务操作、视频双录、线上客服、远程考试培训等方式提供服务，即使客户距银行线下网点远隔千里，也能在远程端切身体验数实融合的新型服务模式。
        </p>
        <div>
          <div class="image-panel">
            <img class="news-image" src="../img/detail/Information/news65/news65_10.png"/>
          </div>
        </div>
        <div class="news-content-mark">
          <div>
            趋势十：Web3 助力打造出海金融科技基础设施
          </div>
        </div>
        <p>
          Web3是指由分布式账本支持，基于区块链架构的新一代互联网。通过分布式系统、共识、密码学等协议和技术构建的可信任的、隐私安全的价值互联网，其主要创新点包括开放、隐私、共建，以及借助区块链和智能合约等技术实现的去中心化。
        </p>
        <p>
          在金融领域，Web3技术可以实现去中心化金融（DeFi），即利用智能合约和预言机打造的一个基于Web3的开放金融系统，旨在无需依赖第三方中心机构的条件下，为用户提供各项金融服务，并支持一体化和标准化的经济体系。例如，Uniswap等去中心化交易协议，可以实现任意两种代币之间的兑换，带来更高的流动性和更低的交易成本。Web3技术的出现将为金融市场提供更大的创新空间，通过建立多方信任、提高资产流通效率，充分满足人们多样的金融需求。
        </p>
        <div>
          <div class="image-panel">
            <img class="news-image" src="../img/detail/Information/news65/news65_11.png"/>
          </div>
        </div>
        <div class="news-content-mark">
          <h2>
            研究团队致谢
          </h2>
        </div>
        <div>
          <div class="image-panel">
            <img class="news-image" src="../img/detail/Information/news65/news65_12.png"/>
          </div>
        </div>
        <div>
          <div class="image-panel">
            <img class="news-image" src="../img/detail/Information/news65/news65_13.png"/>
          </div>
        </div>
        <div>
          <div class="image-panel">
            <img class="news-image" src="../img/detail/Information/news65/news65_14.png"/>
          </div>
        </div>
        <p>
          在<strong>“ 腾讯优图实验室 ”</strong>后台回复关键词<span class="mark-text highlight">“2023金融科技”</span>获取完整版报告PDF
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import BackOpenChenter from '@/components/open/panels/news/detail/BackOpenChenter';
export default {
  name: 'News65',
  components: {
    BackOpenChenter
  }
};
</script>

<style lang="less" scoped>
@import "./news.less";
.news-content {
  margin: 0 auto;
  .image-panel {
    max-width: 667px;
    text-align: center;
    img {
      max-width: 667px;
    }
    span {
      font-size: 12px;
      color: #858585;
    }
  }
  .highlight {
    color: #0052FF;
  }
  .end-divide {
    width: 120px;
    height: 2px;
    margin: 20px auto;
    background: #0152d9;
  }
  .download-article-wrap {
    margin: 0 auto;
    padding: 5px 3px;
    border: 3px solid rgb(1, 82, 217);
    font-family: PingFangSC-light;
    .download-article {
      padding: 5px 10px;
      border-left: 1px solid rgb(1, 82, 217);
      border-right: 1px solid rgb(1, 82, 217);
    }
  }
  .right-text {
    font-size: 12px;
    text-align: right;
    color: #0152d9;
  }
  .news-literature {
    max-height: 180px;
    padding: 15px;
    overflow-y: scroll;
    background-color: #ebebeb;
  }
  .short-center{
    text-align: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/open/panels/news/detail/News65.vue